<template>
    <div class="track__bg bg-full-width">
        <section class="track" id="track">
            <h2 class="tx-white">Track Your Application</h2>
            <div class="track-form b-flex flex-wrap">
                <div class="track-input">
                    <BliField help-text-status="error" label="Enter your email">
                        <BliTextField v-model="trackingForm.email" />
                        <template #help-text>
                            {{ errors.email ? errors.email : '' }}
                        </template>
                    </BliField>
                </div>
                <div class="track-input">
                    <BliField help-text-status="error" label="Enter your Application ID">
                        <BliTextField v-model="trackingForm.code" />
                        <template #help-text>
                            {{ errors.code ? errors.code : '' }}
                        </template>
                    </BliField>
                </div>
                <div class="track__button">
                    <BliButton width="100%" color="inverted" @click="track">
                        Track
                    </BliButton>
                </div>
            </div>
        </section>
    </div>
</template>

<script src="./js/track.js"></script>

<style lang="scss" scoped>
@import '@blibli/blue-dls-utils/dist/scss/responsive-mixins-helper';
@import '@blibli/blue-design-tokens/dist/tokens-default.scss';

.track__bg {
    background-color: $blu-color-info-background-med;
    .track {
        @include mobile {
            padding-top: 3.2rem;
        }

        @include desktop {
            h2 {
                padding-top: 50px;
            }
        }

        &-form>* {
            flex: 0 0 100%;
        }

        &-input .blu-field {
            margin-bottom: 0.8rem;
        }

        p {
            margin: 0.8rem 0;

            @include desktop {
                margin: 1.6rem 0;
            }
        }

        @include desktop {
            &-input {
                flex: 2;
                margin-right: 1.6rem;
            }

            &__button {
                flex: 1;

                .blu-btn.b-full-width {
                    height: 53px;
                }
            }
        }
    }
}
</style>